<template>
  <svg width="19" height="15" viewBox="0 0 19 15" fill="none" class="icon-arrow-left" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.85434 1.00001L2.00001 7.26965L8.85434 13.5393" stroke-width="2" stroke-miterlimit="10"
          stroke-linecap="round"/>
    <path d="M2.92047 7.37035L18 7.37035" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
  </svg>

</template>

<script setup lang="ts">

</script>

<style lang="scss" >
.icon-arrow-left {
  display: block;
  stroke: var(--theme-icon-arrow-left-color);
}
</style>